import React from 'react';
import {
  createIntl, createIntlCache, FormattedMessage, IntlContext,
} from 'react-intl';
import AppLocale from '../lngProvider';

const fallbackIntl = createIntl({
  locale: 'en',
  messages: AppLocale.en?.messages || {},
}, createIntlCache());

const renderFallback = ({ id, values = {}, children }) => {
  const message = fallbackIntl.formatMessage({ id }, values);
  return typeof children === 'function' ? children(message) : message;
};

const IntlMessages = (props) => (
  <IntlContext.Consumer>
    {(intl) => (
      intl
        ? <FormattedMessage {...props} />
        : renderFallback(props)
    )}
  </IntlContext.Consumer>
);

export default IntlMessages;
